import React from "react";
import ComicBase from "../ComicBase";

export default function ComicOnePiece() {
  return (
    <ComicBase
      titulo="Shoutengai no Ana Zuma-tachi parte 1"
      portada="https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-1.jpg"
     paginas={[
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-1.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-2.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-3.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-4.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-5.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-6.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-7.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-8.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-9.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-10.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-11.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-12.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-13.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-14.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-15.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-16.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-17.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-18.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-19.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-20.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-21.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-22.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-23.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-24.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-25.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-26.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-27.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-28.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-29.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-30.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-31.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-32.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-33.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-34.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-35.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-36.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-37.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-38.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-39.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-40.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-41.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-42.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-43.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-44.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-45.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-46.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-47.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-48.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-49.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-50.jpg"
]}
      sugeridos={[]}

      info={{
        grupo: "shoot the moon",
        tipo: "doujinshi",
        idioma: "Español",
        serie: "original",
        personajes: [""],
etiquetas: ["Ahegao", "Beauty Mark", "Big Ass", "Big Breasts", "Big Nipples", "Big Penis", "Cheating", "Cunnilingus", "Digital Fingering", "Hidden Sex", "Kissing", "Milf", "Mind Break", "Multi-work Series", "Nakadashi", "Netorare", "Sole Female", "Sole Male", "X-Ray"],

artistas: "fuetakishi",
      }}
    />
  );
}

export const infoManga = {
  titulo: "Shoutengai no Ana Zuma-tachi parte 1",
  portada: "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-1.jpg",
  reverso: "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi1-3.jpg",
    fecha:"2026-05-11", // 👈 MOVER AQUÍ

  info: {
    grupo: "shoot the moon",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "original",
    personajes: [""],
etiquetas: ["Ahegao", "Beauty Mark", "Big Ass", "Big Breasts", "Big Nipples", "Big Penis", "Cheating", "Cunnilingus", "Digital Fingering", "Hidden Sex", "Kissing", "Milf", "Mind Break", "Multi-work Series", "Nakadashi", "Netorare", "Sole Female", "Sole Male", "X-Ray"],
    artistas: "fuetakishi",

  },
};
